import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setZipcode } from 'helpers/Zipgate';
export const EVAutosListenerProvider = (): JSX.Element => {
  const dispatch = useDispatch();
  const hondaEventName = 'global-zip-update';

  useEffect(() => {
    const updateAutosZipcode = (event: CustomEvent) => {
      if (event.detail) {
        dispatch(setZipcode(event.detail));
      }
    };

    window.addEventListener(hondaEventName, (event) =>
      updateAutosZipcode(event as CustomEvent)
    );

    window.EventManager.subscribe(hondaEventName, updateAutosZipcode);

    return () => {
      window.removeEventListener(hondaEventName, (event) =>
        updateAutosZipcode(event as CustomEvent)
      );

      window.EventManager.unsubscribe(hondaEventName, updateAutosZipcode);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
};
